import { render } from "./AIMethodChangeModal.vue?vue&type=template&id=32d20a2a&scoped=true"
import script from "./AIMethodChangeModal.vue?vue&type=script&lang=js"
export * from "./AIMethodChangeModal.vue?vue&type=script&lang=js"

import "./AIMethodChangeModal.vue?vue&type=style&index=0&id=32d20a2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d20a2a"]])

export default __exports__